/**
 * Shared Forge bridge types (F3) — the client contract for the unified asset
 * format + Canvas↔Forge bridge.
 *
 * The provenance/permission chain lives in P2 (`asset`/`inventory_item`/
 * `provenance_event`); this only mirrors the descriptor + crossing vocabulary the
 * studio renders. The gate (`canRemix` via `bridgePermit`), the fidelity transform,
 * and the royalty hook are all server-authoritative.
 */

/** The bridge crossing directions (P14 AssetBridge). */
export const ASSET_BRIDGE_DIRECTION = {
  CanvasToForge: 'canvas_to_forge',
  ForgeToCanvas: 'forge_to_canvas',
} as const;
export type AssetBridgeDirection = (typeof ASSET_BRIDGE_DIRECTION)[keyof typeof ASSET_BRIDGE_DIRECTION];

/** Canvas baseline fidelity tier; Forge upgrades up to the creator's entitlement cap. */
export const CANVAS_FIDELITY_TIER = 1;
export const FORGE_MAX_FIDELITY_TIER = 4;

/** One fidelity variant in the synthesized ladder. */
export interface FidelityVariant {
  ref: string;
  drawBudget: number;
}
/** The full `{ "<tier>": FidelityVariant }` ladder carried by `assetFormat.fidelityVariants`. */
export type FidelityLadder = Record<string, FidelityVariant>;
